import {observer} from "mobx-react";
import {useStore} from "../../../stores/Store";
import {Accordion, AccordionSummary, Checkbox, FormControlLabel, FormGroup, Typography} from "@mui/material";
import {ExpandMore} from "@mui/icons-material";
import {BassType} from "../../../models/BassType";
import {BaseSyntheticEvent, useEffect} from "react";
import {Brand} from "../../../models/Brand";
import {RightHandSystem} from "../../../models/RightHandSystem";

interface CheckboxFilterProps{
    checkObjects: CheckObject[],
    filteredValue: BassType | Brand | RightHandSystem | number | undefined | string,
    setFilteredValue: (x: any) => void
    setFilteredValueArgumentType?: 'number' | 'string',
    title: string,
    attributeName: string,
}

interface CheckObject {
    value: BassType | Brand | RightHandSystem | number | string,
    label: string
}

export default observer(function CheckboxFilter({title, filteredValue, setFilteredValue, checkObjects, attributeName}: CheckboxFilterProps){
    const { AccordionStore } = useStore();
    const {filteredAccordions} = AccordionStore

    const handleChange = (event: BaseSyntheticEvent) => {
        if(checkObjects[0] && typeof checkObjects[0].value === 'number') setFilteredValue(parseInt(event.target.value))
        else setFilteredValue(event.target.value);
    }

    const filteredResultsAvailable = (checkObject: CheckObject): boolean => {
        if(filteredValue) return false;
        // @ts-ignore
        return filteredAccordions.filter(a => a[attributeName] === checkObject.value).length > 0
    }

    return (
        <Accordion variant={'outlined'}>
            <AccordionSummary
                expandIcon={<ExpandMore />}
            >
                <Typography>{title}</Typography>
            </AccordionSummary>
            <FormGroup sx={{ml: 2}} onChange={handleChange}>
                {
                    checkObjects.map(o =>
                        <FormControlLabel control={
                            <Checkbox
                                disabled = {!filteredResultsAvailable(o) && filteredValue !== o.value}
                                value={o.value}
                                color={'secondary'}
                                checked={filteredValue === o.value}
                            />
                        } label={o.label} key={o.value+o.label}
                        />
                    )
                }
            </FormGroup>
        </Accordion>
    )
})